"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SlashBack: function() {
        return SlashBack;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const SlashBack = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.59313 2.08595C8.09782 1.86165 8.68878 2.08894 8.91308 2.59362L16.9131 20.5936C17.1374 21.0983 16.9101 21.6893 16.4054 21.9136C15.9007 22.1379 15.3098 21.9106 15.0855 21.4059L7.08546 3.4059C6.86116 2.90122 7.08845 2.31025 7.59313 2.08595Z",
        fill: "currentColor"
    })
}), "SlashBack");
const _default = SlashBack;
